app.service('basketDeliveryUnavailable', function (modal, broker, updateServicePrices) {
	var $self, $form, $servicesOnModal, $summary;

	function open() {
		modal.open('delivery-unavailable');
	}

	function setElements() {
		$self = $('#modal-delivery-unavailable');
		$summary = $('.js-services-summary-price', $self);
		$form = $('form', $self);
		$servicesOnModal = $('.js-service', $form);
	}

	function setEvents() {
		$('.js-confirm-home-delivery', $self).on('click', function () {
			modal.close();
			broker.trigger('CONFIRM_HOME_DELIVERY');
		});
		$('.js-resign-home-delivery', $self).on('click', function () {
			modal.close();
			broker.trigger('RESIGN_HOME_DELIVERY');
		});
		broker.on('REFRESH_BASKET_VIEW', function () {
			modal.destroy('delivery-unavailable');
		});
		$('.js-decline-home-delivery-type', $self).on('click', function () {
			modal.close();
			broker.trigger('DECLINE_HOME_DELIVERY', $(this).data('delivery-type') * 1);
		});
		$servicesOnModal.on('click', function () {
			updateExcludedServices.run({
				$input: $(this),
				$inputs: $servicesOnModal
			});
			updateServicePrices.run({
				$inputs: $servicesOnModal,
				$box: $summary
			});
		});
	}
	function init() {
		setElements();
		setEvents();
	}
	return {
		init,
		open
	};
});